const SPECIAL_CHARS_REGEXP = /([:-_]+(.))/g
const MOZ_HACK_REGEXP = /^moz([A-Z])/

export interface StyleObjectInterface {
  [key: string]: any
}

const camelCase = function (name: string): string {
  return name
    .replace(SPECIAL_CHARS_REGEXP, (_, separator, letter, offset) => {
      return offset ? letter.toUpperCase() : letter
    })
    .replace(MOZ_HACK_REGEXP, 'Moz$1')
}

export const isUndefined = (obj: unknown): boolean =>
  Object.prototype.toString.call(obj).toLowerCase() === '[object undefined]'
export const isArray = (obj: unknown): boolean =>
  Object.prototype.toString.call(obj).toLowerCase() === '[object array]'
export const isObject = (obj: unknown): boolean =>
  Object.prototype.toString.call(obj).toLowerCase() === '[object object]'
export const isString = (obj: unknown): boolean =>
  Object.prototype.toString.call(obj).toLowerCase() === '[object string]'
export const isBoolean = (obj: unknown): boolean =>
  Object.prototype.toString.call(obj).toLowerCase() === '[object boolean]'

// 获取字符串样式获取属性值
export function getStyleValue(source: string | object, styleName: string) {
  if (!source) return ''
  const styleObj: StyleObjectInterface = mergeStyle(source, {})
  return styleObj[styleName] || ''
}

// 合并样式
export function mergeStyle(
  source: string | StyleObjectInterface,
  target: StyleObjectInterface
): StyleObjectInterface {
  let styleObj: StyleObjectInterface = {}
  if (!source) return target || {}
  if (isString(source)) {
    // 先清空多余空格
    source = (source as string).replace(/\s*/g, '')
    // 拆分样式
    const styleArr = source.split(';')
    styleArr.forEach((item: string): void => {
      const itemSplit = item.split(':')
      if (itemSplit && itemSplit[0]) {
        const key = camelCase(itemSplit[0])
        const val = itemSplit[1] || ''
        if (isUndefined(styleObj[key])) {
          styleObj[key] = val
        } else if (isArray(styleObj[key])) {
          styleObj[key].push(val)
        } else {
          styleObj[key] = [styleObj[key], val]
        }
      }
    })
  } else if (isObject(source)) {
    // 样式对象
    styleObj = { ...(source as StyleObjectInterface) }
  }
  return Object.assign(styleObj, target || {}) as StyleObjectInterface
}

export function getCurrentStyle(el: HTMLElement, styleName: any): any {
  return window.getComputedStyle(el)[styleName]
}
